export default "__VITE_ASSET__Cizr9Pkd__"